import type { Item } from '@finsim/model';
import {
  ArrowDownLeft,
  ArrowUpRight,
  Banknote,
  Briefcase,
  Building2,
  CalendarClock,
  Car,
  CreditCard,
  Gift,
  Home,
  Landmark,
  Lightbulb,
  PiggyBank,
  Receipt,
  Repeat,
  ShoppingBag,
  Sigma,
  TrendingUp,
  type LucideIcon,
} from 'lucide-react';

const BY_TEMPLATE: Record<string, LucideIcon> = {
  salary: Briefcase,
  rentReceived: Building2,
  rentPaid: Home,
  utilities: Lightbulb,
  livingCosts: ShoppingBag,
  subscription: Repeat,
  bonus: Gift,
  purchase: Car,
  inheritance: Landmark,
  savings: PiggyBank,
  investment: TrendingUp,
  property: Home,
  mortgage: Landmark,
  consumerLoan: CreditCard,
  incomeTax: Receipt,
  salaryTaxBg: Receipt,
  savingsRule: Sigma,
};

/** Icon for an item: by template, falling back to its primitive and direction. */
export function itemIcon(
  item: Pick<Item, 'template' | 'type'> & { direction?: 'in' | 'out' },
): LucideIcon {
  const byTemplate = BY_TEMPLATE[item.template];
  if (byTemplate) return byTemplate;
  switch (item.type) {
    case 'asset':
      return PiggyBank;
    case 'loan':
      return CreditCard;
    case 'formula':
      return Sigma;
    case 'flow':
      return item.direction === 'in'
        ? ArrowDownLeft
        : item.direction === 'out'
          ? ArrowUpRight
          : Banknote;
  }
}

export const EventIcon = CalendarClock;
